import { IdName } from "@shared/models/id-name";

export function getSortedListByName<T extends IdName>(list: T[]): T[] {
	return list?.sort((a, b) => {
		if (a.Name < b.Name) { return -1; }
		if (a.Name > b.Name) { return 1; }
		return 0;
	})
}